// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item[data-v-e4d00e66]{\n  border-radius: 20px;\n  overflow: hidden;\n  background-color: #dcdcdc;\n}\n", ""]);
